import { CookieParseOptions, CookieSerializeOptions } from "cookie-es";
import { SignInData } from "ecom-types";

export enum cookiesNamesEnum {
  cart_unique_id = "cart_unique_id",
  client_ip = "client_ip",
  order_address = "order_address",
  uid = "uid",
  irclickid = "irclickid",
  wishlist_id = "wishlist_id",
  access_token = "access_token",
}

type CookiesServiceOptions = Record<
  cookiesNamesEnum,
  Omit<CookieSerializeOptions & CookieParseOptions, "decode" | "encode">
>;

export function useCookiesService(options?: Partial<CookiesServiceOptions>) {
  const cartUniqueId = useCookie(cookiesNamesEnum.cart_unique_id);
  const clientIp = useCookie(cookiesNamesEnum.client_ip);
  const orderAddress = useCookie(cookiesNamesEnum.order_address);
  const uidCookie = useCookie<string>(cookiesNamesEnum.uid);
  const irclickid = useCookie(cookiesNamesEnum.irclickid);
  const wishlistId = useCookie(cookiesNamesEnum.wishlist_id, {
    maxAge: 60 * 60 * 24 * 3,
  });
  const accessTokenData = useCookie<SignInData["access_token"] | null>(
    cookiesNamesEnum.access_token,
    options && options?.[cookiesNamesEnum.access_token]
      ? options[cookiesNamesEnum.access_token]
      : {},
  );

  return {
    cartUniqueId,
    clientIp,
    orderAddress,
    uidCookie,
    irclickid,
    wishlistId,
    accessTokenData,
  };
}
